import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground group-data-[type=error]:!text-red-200 group-data-[type=success]:!text-emerald-200",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error: "group-[.toaster]:!bg-red-950 group-[.toaster]:!text-red-100 group-[.toaster]:!border-red-500/50",
          success: "group-[.toaster]:!bg-emerald-950 group-[.toaster]:!text-emerald-100 group-[.toaster]:!border-emerald-500/40",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
